import { ApplicationType } from "@/store/slices/types/applicationFormSlice";
import { getIsConsumerOrPersonalApplication } from "@/constants";

const getFieldsCustomLabel = (applicationType: ApplicationType): Record<string, string> => {
  const isConsumerOrPersonalApplication = getIsConsumerOrPersonalApplication(applicationType);
  return {
    customerRequired: isConsumerOrPersonalApplication
      ? "At least 1 borrower"
      : "At least 1 guarantor",
    entityRequired: "At least 1 entity",
    supplierABN: "Supplier ABN",
    vin: "VIN",
    glassesNVIC: "Glasses NVIC",
    assetValue: "Purchase price",
    ageOfAsset: "Year of manufacture",
    addressIsAtLeast36Months: "Addresses of at least 36 months",
    introducerDeclarationAgree: 'Introducer declaration'
  };
};

export { getFieldsCustomLabel };
